import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RemoteManagerComponent} from './remote-manager.component';
import {ArmFormModule} from '../../../components/arm-form/arm-form.module';
import {ArmFormTitleModule} from '../../../components/arm-form/arm-form-title/arm-form-title.module';
import {FormsModule} from '@angular/forms';
import {MaterialModule} from '../../../material.module';
import {InfraModule} from 'ac-infra';



@NgModule({
  declarations: [RemoteManagerComponent],
  imports: [
    CommonModule,
    ArmFormModule,
    MaterialModule,
    ArmFormTitleModule,
    FormsModule,
    InfraModule
  ]
})
export class RemoteManagerModule { }
